import { ReactNode } from "react"

export interface IMessage {
    title?: ReactNode
    descr?: ReactNode
    type?: "default" | "error"
    duration?: number
}

export default class Message implements IMessage {
    title?: ReactNode
    descr?: ReactNode
    type?: "default" | "error"
    duration?: number

    constructor({title, descr, type = "default", duration = 3200}: IMessage) {
        this.title = title
        this.descr = descr
        this.type = type
        this.duration = duration
    }
}
